import React from 'react' // eslint-disable-line no-unused-vars
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import './App.scss'
import create_store from './state/store'
import PullRequestList from './components/PullRequestList'
import Config from './components/Config'

function App() {
  const {store, persistor} = create_store()
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="app" draggable={false}>
          <Config />
          <PullRequestList />
        </div>
      </PersistGate>
    </Provider>
  )
}

export default App
